<div *ngIf="visible" class="dialog-container">
  <div
    class="dialog-backdrop"
    *ngIf="modal"
    (click)="onMaskClick()"
    [@backdropAnimation]>
  </div>

  <div
    #dialog
    class="dialog"
    [ngClass]="'dialog-' + position"
    [ngStyle]="{
      'width': width,
      'height': height
    }"
    (click)="onDialogClick($event)"
    [@dialogAnimation]>

    <div class="dialog-header" *ngIf="showHeader">
      <ng-container *ngIf="headerTemplate; else defaultHeader">
        <ng-container *ngTemplateOutlet="headerTemplate"></ng-container>
      </ng-container>
      <ng-template #defaultHeader>
        <h3 class="dialog-title">{{ header | translate }}</h3>
        <button
          *ngIf="closable"
          type="button"
          class="dialog-close-button"
          (click)="hide()">
          <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M15 5L5 15M5 5L15 15" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
          </svg>
        </button>
      </ng-template>
    </div>

    <div class="dialog-content">
      <ng-container *ngIf="contentTemplate; else defaultContent">
        <ng-container *ngTemplateOutlet="contentTemplate"></ng-container>
      </ng-container>
      <ng-template #defaultContent>
        <ng-content></ng-content>
      </ng-template>
    </div>

    <div class="dialog-footer" *ngIf="showFooter && footerTemplate">
      <ng-container *ngTemplateOutlet="footerTemplate"></ng-container>
    </div>
  </div>
</div>
